import brandLogo from '../images/brand-logo.avif';

/**
 * Beko brand logo. Unlike the other brands (inline SVG wordmarks), Beko's
 * production logo is a raster asset (`brand-logo.avif`, from the live Beko app).
 * Imported so Vite resolves the correct base-aware, content-hashed URL (the app
 * is served under a `/register` base, so a hardcoded `/brand-logo.avif` would
 * 404). Rendered at the same 24px height the other brands' logos use so the
 * header layout is unchanged; `alt` mirrors the live Beko site.
 */
export const ClientLogo = () => (
  <img src={brandLogo} alt="Beko" style={{ height: 24, width: 'auto' }} />
);
